import React from 'react';
import { EditIcon } from '../../../../Components/Icons';

export const getTableActions = (handleEditActionOnClick, editActionTooltip) => [
  {
    icon: () => <EditIcon aria-label={'edit action'} />,
    tooltip: editActionTooltip,
    onClick: (_e, rowData) => {
      handleEditActionOnClick(rowData.propertyId);
    },
  },
];
